import { render, staticRenderFns } from "./notice-info.vue?vue&type=template&id=9c1371e8&"
import script from "./notice-info.vue?vue&type=script&lang=js&"
export * from "./notice-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "notice-info.vue"
export default component.exports